"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkDto = void 0;
const LocationDto_1 = require("../locations/LocationDto");
class LinkDto {
    constructor(params) {
        this.name = "";
        this.linkType = "";
        this.typeOfIcon = "";
        this.url = "";
        this.createdAt = "";
        this.updatedAt = "";
        this.iconFileName = "";
        this.iconContentType = "";
        this.iconUpdatedAt = "";
        if (!params) {
            return;
        }
        this.id = params.id;
        this.locationId = params.locationId;
        this.name = params.name;
        this.linkType = params.linkType;
        this.typeOfIcon = params.typeOfIcon;
        this.manufacturerIconId = params.manufacturerIconId;
        this.url = params.url;
        this.createdAt = params.createdAt;
        this.updatedAt = params.updatedAt;
        this.iconFileName = params.iconFileName;
        this.iconContentType = params.iconContentType;
        this.iconFileSize = params.iconFileSize;
        this.iconUpdatedAt = params.iconUpdatedAt;
        this.position = params.position;
        if (params.location !== undefined) {
            this.location = params.location ? new LocationDto_1.LocationDto(params.location) : null;
        }
    }
}
exports.LinkDto = LinkDto;
//# sourceMappingURL=LinkDto.js.map